import { render, staticRenderFns } from "./createUsers.vue?vue&type=template&id=0d705962&scoped=true"
import script from "./createUsers.vue?vue&type=script&lang=js"
export * from "./createUsers.vue?vue&type=script&lang=js"
import style0 from "./createUsers.vue?vue&type=style&index=0&id=0d705962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d705962",
  null
  
)

export default component.exports